import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { FactCheck as FinishIcon } from '@mui/icons-material';
import { GlobalButton } from '@/components';
import React from 'react';

interface ConcludeScanProps {
  onConclude: () => void;
  disabled: boolean;
}

const ConcludeScan: React.FC<ConcludeScanProps> = ({
  onConclude,
  disabled,
}) => {
  return (
    <div className='bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 p-6'>
      <div className='flex flex-col md:flex-row items-center justify-between gap-8'>
        <div className='flex items-center gap-4'>
          <div className='w-12 h-12 rounded-2xl bg-orange-50 flex items-center justify-center text-[#ff7500]'>
            <FinishIcon sx={{ fontSize: 24 }} />
          </div>
          <div className='flex flex-col'>
            <span className='text-[11px] font-bold text-gray-400 uppercase tracking-wider leading-none mb-1'>
              Gestión de Importación
            </span>
            <span className='text-lg font-black text-gray-800 leading-none'>
              Finalizar Sesión de Arribo
            </span>
          </div>
        </div>

        <div className='flex items-center gap-4'>
          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={onConclude}
            disabled={disabled}
          >
            <FinishIcon sx={{ mr: 1, fontSize: 20 }} />
            CONFIRMAR RECEPCIÓN
          </GlobalButton>
        </div>
      </div>
    </div>
  );
};

export default ConcludeScan;
